import { h, RefObject } from 'preact';
import { useContext } from 'preact/hooks';
import { classNames } from '../../css';
import { CSSAttribute } from '../../types';
import { PreviewContext } from '../contexts/previewContext';
import { useMaxSlotSize } from '../hooks/useMaxSlotSize';
import { useRTL } from '../hooks/useRTL';

const BorderSize = 1;

const DefaultIsRtl = () => false;

interface CreativeComponentProps<TConfig> {
  adRef?: RefObject<any>;
  onClick?: (evt: MouseEvent) => void;
  children?: any;
  className?: string;
  style?: CSSAttribute;
  isRTL?: (c: TConfig) => boolean;
}

export function CreativeComponent<TConfig = unknown>({
  onClick,
  adRef,
  children,
  className = '',
  style = {},
  isRTL = DefaultIsRtl,
}: CreativeComponentProps<TConfig>) {
  const rtlClassName = useRTL(isRTL);
  const maxSlotSize = useMaxSlotSize();
  const preview = useContext(PreviewContext);

  return (
    <div style={maxSlotSize}>
      <div
        ref={adRef}
        onClick={onClick}
        style={{
          cursor: preview ? 'default' : 'pointer',
          display: 'flex',
          flexDirection: 'column',
          fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif',
          border: `solid ${BorderSize}px #f1f1f1`,
          boxSizing: 'border-box',
          overflow: 'hidden',
          maxHeight: '100%',
          ...style,
        }}
        className={classNames(className, rtlClassName)}
      >
        {children}
      </div>
    </div>
  );
}
